import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import api from "@/lib/api";
import SEO from "@/components/SEO";
import PageHero from "@/components/site/PageHero";
import { PortfolioCard } from "@/components/site/cards";
import { ContactCTA } from "@/pages/Home";

export default function Portfolio() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("All");

  useEffect(() => {
    api.get("/portfolio").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  const categories = ["All", ...new Set(items.map((i) => i.category))];
  const filtered = filter === "All" ? items : items.filter((i) => i.category === filter);

  return (
    <>
      <SEO title="Portfolio" description="Explore award-winning work by Web Vantage Enterprises — web apps, ecommerce, mobile apps, branding and more." path="/portfolio" />
      <PageHero
        overline="Portfolio"
        title="Work that speaks louder than promises"
        subtitle="A selection of products we've designed, built and grown for ambitious brands around the world."
        crumbs={[{ label: "Portfolio" }]}
      />
      <section className="py-20 lg:py-28">
        <div className="container-wv">
          <div className="mb-12 flex flex-wrap gap-3">
            {categories.map((c) => (
              <button
                key={c}
                onClick={() => setFilter(c)}
                data-testid={`portfolio-filter-${c.toLowerCase().replace(/\s+/g, "-")}`}
                className={`rounded-full px-5 py-2 text-sm font-medium transition-colors ${
                  filter === c ? "bg-vantage text-white" : "border border-white/10 text-slate-400 hover:text-white"
                }`}
              >
                {c}
              </button>
            ))}
          </div>
          <motion.div layout className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
            <AnimatePresence mode="popLayout">
              {filtered.map((item, i) => (
                <motion.div key={item.id} layout initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.95 }} transition={{ duration: 0.35 }}>
                  <PortfolioCard item={item} index={i} />
                </motion.div>
              ))}
            </AnimatePresence>
          </motion.div>
        </div>
      </section>
      <ContactCTA />
    </>
  );
}
